import { RateReviewRounded } from "@mui/icons-material";
import { Avatar, AvatarGroup, Box, Container, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Paper, Tooltip, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { collection, getFirestore, onSnapshot, onSnapshotsInSync, orderBy, query, Unsubscribe } from "firebase/firestore";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { messageThreadConverter } from "../../converters/messageThreadConverter";
import { useAppSelector } from "../../store";
import { Employee } from "../../types/Employee";
import { MessageThread, MessageThreadMember } from '../../types/MessageThread';
import { queryEmployee } from "../../utils/queryEmployee";

type MessagesHomePageProps = {

};
export const MessagesHomePage = (props: MessagesHomePageProps) => {
  const db = getFirestore();
  
  const navigate = useNavigate();
  const { threadId } = useParams();
  const me = useAppSelector((s) => s.auth) as unknown as Employee;

  const [threads, setThreads] = useState<MessageThread[]>([]);

  const handleStartConvoOnClick = () => {
    navigate('/messages/t/start-conversation', { replace: true });
  };

  useEffect(() => {
    setThreads([]);

    return onSnapshot(
      query(
        collection(db, `Employees/${me.idNumber}/Messages`), orderBy('lastUpdate', 'desc')).withConverter(messageThreadConverter), async (snapshot) => {
        const docChanges = snapshot.docChanges()
        for (let i = 0; i < docChanges.length; i++) {
          const change = docChanges[i];
          const thread = change.doc.data();

          const members: MessageThreadMember[] = [...thread.members];
          for (let j = 0; j < thread.members.length; j++) {
            let e: Employee | undefined = me
            if (thread.members[j].idNumber !== me.idNumber) {
              e = await queryEmployee(thread.members[j].idNumber);
            }
            if (e) {
              members[j] = {
                ...members[j],
                employee: e
              }
            }
          }

          if (change.type === 'added') {
            setThreads(prev => [...prev, { ...thread, members }])
          }
        }
    });
  }, [])

  return (
    <Container disableGutters>
      <Stack direction="row" spacing={1}>
        <Paper sx={{
          minWidth: 400, width: 400,
        }}>
          <Stack direction="row" spacing={1} padding={1}>
            <Box display="flex" flexGrow={1} alignItems="center">
              <Typography>Messages</Typography>
            </Box>
            <Tooltip title="Start new conversation">
              <IconButton onClick={handleStartConvoOnClick}>
                <RateReviewRounded />
              </IconButton>
            </Tooltip>
          </Stack>
          <Box sx={{ 
            height: 'calc(100vh - 200px - 56px)',
            maxHeight: 'calc(100vh - 200px - 56px)',
            overflowY: 'scroll',
          }}>
            <List sx={{ pt: 0 }}>
              {threads.map((t, i) => {
                return (
                  <ListItem key={t.id} selected={threadId === t.id} disablePadding>
                    <ListItemButton onClick={() => navigate(`/messages/t/${t.id}`)}>
                      <ListItemAvatar sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <AvatarGroup>
                          {t.members.filter((m) => m.idNumber !== me.idNumber).map((m) => {
                            if (m.employee === undefined) {
                              return (
                                <Avatar>A</Avatar>
                              )
                            } else {
                              return (
                                <Avatar key={m.employee.uid} src={m.employee.picture} alt={m.employee.name} />
                              );
                            }
                          })}
                        </AvatarGroup>
                      </ListItemAvatar>
                      <ListItemText
                        primary={t.members.filter((m) => m.employee?.idNumber !== me.idNumber).map((m) => m.employee?.name).join(', ')}
                        secondary={t.lastUpdate.toLocaleString(DateTime.DATETIME_MED)} />
                    </ListItemButton>
                  </ListItem>
                )
              })}
            </List>
          </Box>
        </Paper>
        <Box 
          sx={{ 
            display: 'flex', 
            flexGrow: 1, 
            height: 'calc(100vh - 200px)', maxHeight: 'calc(100vh - 200px)'
          }}>
          <Outlet />
        </Box>
      </Stack>
    </Container>
  );
};